class ApiIntegrationDatatable {

    constructor(tableId) {
        this.datatable = this.initDatatable('#'+tableId);
        const thisClass = this;
        this.initSearchActions();
    }
    initSearchActions(){
        const thisClass = this;
        let timer;
        const input = document.getElementById('apiIntegrationSearchInput');
        if(input){
            input.addEventListener('keyup', function (e) {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    thisClass.datatable.search(e.target.value).draw();
                }, 300);
            });
        }
    }
    initDatatable(el) {


        const thisClass = this;
        const datatable = $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,

            ajax: {
                url: '?do=getApiIntegrations',
                type: 'POST',
                data: {
                    organizationID: new URLSearchParams(window.location.search).get('organizationID')
                }

            },
            language: {
                emptyTable: "No data found"
            },
            columnDefs: [
                { "width": "25%", "targets": 0 },
                { "width": "40%", "targets": 1 },
                { "width": "15%", "targets": 2 },
                { "width": "25%", "targets": 3 },
                {
                    "defaultContent": "-",
                    "targets": "_all"
                }],
            drawCallback: function(settings) {
                $('.show-api-integration-modal').click(function () {
                    new ModalLoading();
                    naja.makeRequest('GET', '?do=getIntegrationDetails', {
                        'apiIntegrationId': $(this).attr('integration-id'),
                        'organizationID': new URLSearchParams(window.location.search).get('organizationID')
                    }, {
                        history: false // Prevent URL changes in browser history
                    }).then((response) => {
                        if(response) {
                            $('#api_integration_detail_modal').modal('show');
                            new ApiIntegrationDetailRequestDatatable('api-integration-detail-communication-datatable',response.editedIntegrationId);
                            new ApiIntegrationDetailOverview(response.editedIntegrationId);

                            new ModalLoading(document.getElementById('api_integration_detail_modal'));
                        }
                    }).catch(error => {
                        new ModalLoading();
                        toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                    });
                });

                $('.test-integration-modal').click(function () {
                    new ApiIntegrationTestConnection($(this).attr('integration-id'));
                });

               $('.delete-integration').click(function () {
                       Swal.fire({
                           html: `<span class="text-center text-primary">Are you sure you want to remove this API Integration?</span>`,
                           icon: "warning",
                           iconColor: "#FF5206",
                           buttonsStyling: false,
                           reverseButtons: true,
                           showCancelButton: true,
                           cancelButtonText: "Cancel",
                           confirmButtonText: "Yes, delete!",
                           customClass: {
                               confirmButton: "btn btn-danger",
                               cancelButton: 'btn btn-light-primary'
                           },
                       }).then((result) => {
                           if (result.isConfirmed) {
                               $.ajax({
                                   url: '?do=removeIntegration',
                                   type: 'POST',
                                   dataType: '',
                                   data: {'integrationId': $(this).attr('integration-id')},
                               }).done(function (data) {
                                   datatable.ajax.reload();
                                   window.location.reload();
                               });
                           }
                       });
               });
            },
            columns: [
                {
                    data: 'id',
                    title: 'Details',
                    sortable: true,
                    render: function (data, type, row) {

                        var lineColor = 'success';
                        var lineWidth = 0;

                        if(row.daily_quote_percent >= 80) {
                            lineColor = 'warning';
                        }
                        if(row.daily_quote_percent >= 100) {
                            lineColor = 'danger';
                        }

                        lineWidth = row.daily_quote_percent;
                        if(row.daily_quote_percent > 100) {
                            lineWidth = 100;
                        }


                        return '<a class="show-api-integration-modal text-decoration-underline-ga primary" integration-id="'+row.id+'"><b>'+row.name+'</b></a><br>'+
                            '<div class="d-flex align-items-center w-200px w-sm-300px flex-column mt-3">\n' +
                            '<div class="d-flex justify-content-between w-100 mt-auto mb-2">\n' +
                            '     <span class="fw-semibold fs-6 text-gray-500">Daily Quote Usage</span>\n' +
                            '     <span class="fw-bold fs-6">'+lineWidth+'%</span>\n' +
                            '</div>\n' +
                            '\n' +
                            '<div class="h-5px mx-3 w-100 bg-light mb-3">\n' +
                            '    <div class="bg-'+lineColor+' rounded h-5px" role="progressbar" style="width: '+lineWidth+'%;" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>\n' +
                            '</div>\n' +
                            '</div>';
                    }
                },
                {
                    data: 'last_used',
                    title: 'Last Used',
                    sortable: true,
                    width: '25%',
                    render: function (data, type, row) {
                        return row.last_used;
                    }
                },
                {
                    data: 'token_expiration',
                    title: 'Expiration',
                    sortable: true,
                    width: '25%',
                    render: function (data, type, row) {
                        return row.token_expiration;
                    }
                },

                {
                    data: 'restrictions',
                    title: 'Restriction',
                    sortable: true,
                    render: function (data, type, row) {
                        var message = '';

                        let ip_restriction_mark    = '<span class="text-danger">Disabled</span>';
                        let scope_restriction_mark   = '<span class="text-danger">Disabled</span>' ;

                        if(row['is_ip_restriction_enabled']){
                            ip_restriction_mark = '<span class="text-success">Enabled</span>';
                        }
                        if(row['is_scope_restriction_enabled']){
                            scope_restriction_mark = '<span class="text-success">Enabled</span>';
                        }
                        return '<div class="d-flex flex-stack">' +
                            '       <div class="d-flex flex-stack flex-row-fluid d-grid gap-2">' +
                            '           <div class="me-5">' +
                            message +
                            '               <span class="fw-semibold d-block fs-7 ga-text-primary-800">IP&nbsp;Restriction:&nbsp;<span class="connection_status_datetime">'+ip_restriction_mark+'<span></span>' +
                            '               <span class="fw-semibold d-block fs-7 ga-text-primary-800">Scope&nbsp;Restriction:&nbsp;<span class="connection_status_datetime">'+scope_restriction_mark+'<span></span>' +
                            '           </div>\n' +
                            '        </div>\n' +
                            '   </div>';
                    }
                },
                {
                    data: '',
                    title: 'Actions',
                    sortable: true,
                    render: function (data, type, row) {
                        let html = '<div class="datatable-action min-w-3 d-flex" id="'+row['uuid']+'">';
                        let editHtml = '';

                        editHtml += '<div class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2 show-api-integration-modal" integration-id="'+row.id+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover">' +
                            '           <span class="svg-icon svg-icon-3">' +
                            '               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                            '                   <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>\n' +
                            '                   <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>\n' +
                            '               </svg>' +
                            '           </span>' +
                            '</div>';

                        html += editHtml;
                        if(row['edit']){
                            html += '<div class="btn btn-icon btn-bg-light btn-sm delete-integration" integration-id="'+row.id+'" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true">'+
                                '                   <span class="svg-icon svg-icon-3">' +
                                '                       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                '                           <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '                           <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"></path>' +
                                '                       </svg>' +
                                '                   </span>' +
                                '               </div>';
                        }

                        return html+'</div>';
                    }
                }
            ]
        }).on('init.dt', function () {
            if(datatable.page.info().recordsTotal === 0){
                //$('#gateways-datatable_wrapper').hide();
                //$('#gateways-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            }
        });
        return datatable;
    }
}
window.ApiIntegrationDatatable = ApiIntegrationDatatable;